import {
  AsyncGridColumns,
  ColumnChipList,
  ColumnLink,
} from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.full name',
    field: 'name',
    sortable: false,
    flex: 1,
    minWidth: 240,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.name}</ColumnLink>,
  },
  {
    headerName: 'column.email',
    field: 'email',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.timezone',
    field: 'timezone',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.roles',
    field: 'rolesIds',
    sortable: false,
    flex: 1,
    minWidth: 220,
    renderCell: ({ value }) => <ColumnChipList items={value} />,
  },
]
